import { NodeViewWrapper } from '@tiptap/react';
import React from 'react';
import cn from 'classnames';
import SolidButton from '@wix/da-ds/pkg/Buttons/SolidButton';
import IconClose from '@wix/da-ds/pkg/Icons/24x24/Close';
import EditorIconButton from '../../../../components/menus/_partials/EditorIconButton';
import s from './MuroBlock.scss';
const MuroBlock = (props)=>{
    // const { node, editor } = props;
    // const { options } = extension;
    const Renderer = props.editor.extensionStorage['da-ext-renderers'].muroMini;
    return /*#__PURE__*/ React.createElement(NodeViewWrapper, {
        className: cn(s['root'], 'ds-surface-tertiary')
    }, /*#__PURE__*/ React.createElement("div", {
        className: s['content']
    }, /*#__PURE__*/ React.createElement("div", {
        className: s['head']
    }, /*#__PURE__*/ React.createElement(SolidButton, {
        size: "medium",
        variant: "edit-purple",
        onClick: ()=>{
            props.editor.chain().focus().daMuroUseDrawing().run();
        }
    }, "Use Drawing"), /*#__PURE__*/ React.createElement(EditorIconButton, {
        icon: IconClose,
        onClick: ()=>{
            props.editor.chain().focus().daMuroDelete().run();
        }
    })), /*#__PURE__*/ React.createElement("div", {
        style: {
            position: 'relative'
        }
    }, /*#__PURE__*/ React.createElement(Renderer, null))));
};
MuroBlock.displayName = 'MuroBlock';
export default MuroBlock;

//# sourceMappingURL=MuroBlock.js.map